function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M216.82,70.174l-61.951-56.333c-2.123-1.93-5.158-2.479-7.818-1.42L4.727,69.049c-3.061,1.218-4.93,4.271-4.703,7.489 C0.014,76.698,0,76.856,0,77.017v32.078c0,4.143,3.357,7.5,7.5,7.5c14.104,0,25.576,11.474,25.576,25.577 S21.604,167.751,7.5,167.751c-4.143,0-7.5,3.357-7.5,7.5v24.977c0,4.143,3.357,7.5,7.5,7.5h204.598c4.143,0,7.5-3.357,7.5-7.5 V77.017c0-0.103-0.01-0.204-0.016-0.307c0.021-0.229,0.035-0.459,0.035-0.693C219.617,73.655,218.525,71.549,216.82,70.174z  M148.242,28.09l44.459,40.428H46.637L148.242,28.09z M204.598,192.728H15v-10.673c18.803-3.528,33.076-20.07,33.076-39.883 S33.803,105.818,15,102.29V83.517h189.598V192.728z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174.094,
  cy: 119.719,
  r: 10.035
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76.621,
  cy: 128.903,
  r: 10.44
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150.315,
  cy: 155.175,
  r: 14.25
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98.102,
  cy: 166.85,
  r: 11.815
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122.855,
  cy: 109.572,
  r: 12.344
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgCheese = function SvgCheese(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 219.617 219.617",
    style: {
      enableBackground: "new 0 0 219.617 219.617"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheese, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cheese.751c042f.svg";
export { ForwardRef as ReactComponent };